import { replace } from 'lodash';
import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fCurrencyWithDomain(number, domain = null) {
  // Get current domain if not provided
  if (!domain) {
    const hostSubArray = window.location.host.split(".");
    domain = hostSubArray[hostSubArray.length - 2];
  }
  
  // Use Rs for all domains except avvtech
  const currencySymbol = domain === 'avvtech' ? '$' : 'Rs';
  return numeral(number).format(Number.isInteger(number) ? `${currencySymbol}0,0` : `${currencySymbol}0,0.00`);
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}
